export default "__VITE_ASSET__aec623ad__"